import React from 'react';
import '../../restock.css'
import CardPayment from '../card/CardPayment'


const MainPayment = () => {
    return(
            <div className="key-holder">
                <CardPayment/>
            </div>
    )
};

export default MainPayment;
